import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Import and register controllers
import MaskController from "./mask_controller";
application.register("mask", MaskController);

import MembersController from "./members_controller";
application.register("members", MembersController);

import PropertySelectController from "./property_select_controller";
application.register("property-select", PropertySelectController);

import MemberSelectController from "./member_select_controller";
application.register("member-select", MemberSelectController);

import ConditionalFieldsController from "./conditional_fields_controller";
application.register("conditional-fields", ConditionalFieldsController);

import TomSelectController from "./tom_select_controller";
application.register("tom-select", TomSelectController);

import AccountSearchController from "./account_search_controller";
application.register("account-search", AccountSearchController);

export { application };
